import React from 'react';
import { Button, ButtonProps } from '../../Button';
import { useCustomComponent } from '@/hooks';

export interface ChatInputSendButtonProps extends ButtonProps {}

const SendButtonComponent: React.FC<ChatInputSendButtonProps> = props => {
  return <Button {...props} />;
};

export const SendButton: React.FC<ChatInputSendButtonProps> = (
  props: ChatInputSendButtonProps
) => {
  const Component = useCustomComponent({
    componentName: 'ChatInputSendButton',
    Component: SendButtonComponent,
  });

  return <Component {...props} />;
};


